import InfoSubList from "./InfoSubList";
export default InfoSubList;